module.exports = __webpack_public_path__ + "img/11.36c4f785.jpg";